import type { ForceLogoProps } from "../types";

/**
 * GAのForceロゴアイコン
 */
export function ForceLogoGA({ size = 36, ...props }: ForceLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.9922 17.3008H16.5234V23.2227C15.9245 23.4206 15.3021 23.5794 14.6562 23.6992C14.0104 23.8138 13.2786 23.8711 12.4609 23.8711C11.3255 23.8711 10.362 23.6471 9.57031 23.1992C8.77865 22.7513 8.17708 22.0898 7.76562 21.2148C7.35417 20.3398 7.14844 19.2643 7.14844 17.9883C7.14844 16.7904 7.3776 15.7539 7.83594 14.8789C8.29948 14.0039 8.97396 13.3268 9.85938 12.8477C10.75 12.3685 11.8359 12.1289 13.1172 12.1289C13.7214 12.1289 14.3177 12.194 14.9062 12.3242C15.4948 12.4544 16.0286 12.6237 16.5078 12.832L15.7031 14.7695C15.3542 14.5924 14.9557 14.444 14.5078 14.3242C14.0599 14.2044 13.5911 14.1445 13.1016 14.1445C12.3984 14.1445 11.7865 14.306 11.2656 14.6289C10.75 14.9518 10.349 15.4049 10.0625 15.9883C9.78125 16.5664 9.64062 17.2487 9.64062 18.0352C9.64062 18.7799 9.74219 19.4414 9.94531 20.0195C10.1484 20.5924 10.4688 21.043 10.9062 21.3711C11.3438 21.694 11.9141 21.8555 12.6172 21.8555C12.9609 21.8555 13.25 21.8398 13.4844 21.8086C13.724 21.7721 13.9479 21.7357 14.1562 21.6992V19.3164H11.9922V17.3008Z"
        fill="#25506B"
      />
      <path
        d="M26.2422 23.7148L25.4141 20.9961H21.25L20.4219 23.7148H17.8125L21.8438 12.2461H24.8047L28.8516 23.7148H26.2422ZM24.8359 18.9648L24.0078 16.3086C23.9557 16.1315 23.8854 15.9049 23.7969 15.6289C23.7135 15.3477 23.6276 15.0638 23.5391 14.7773C23.4557 14.4857 23.388 14.2331 23.3359 14.0195C23.2839 14.2331 23.2109 14.4987 23.1172 14.8164C23.0286 15.1289 22.9427 15.4258 22.8594 15.707C22.776 15.9883 22.7161 16.1888 22.6797 16.3086L21.8594 18.9648H24.8359Z"
        fill="#25506B"
      />
    </svg>
  );
}
